<template>
  <view class="scroll-main">
    <!-- 左侧列表内容部分 -->
    <scroll-view
      class="content"
      enable-back-to-top
      scroll-into-view="{{toView}}"
      scroll-y
      scroll-with-animation
      bindscroll="onPageScroll"
    >
      <view id="inToView-1" data-id="-1">
        <slot></slot>
        <view class="orientation_title"> 字母索引 </view>
        <view class="orientation_region">
          <block wx:for="{{listMain}}" wx:key="{{item.id}}">
            <view class="orientation_city" bindtap="scrollToViewFn(item.id)">
              {{ item.region }}
            </view>
          </block>
        </view>
      </view>
      <view
        wx:for="{{listMain}}"
        wx:for-item="group"
        wx:key="{{group.id}}"
        id="{{ 'inToView'+group.id}}"
        data-id="{{group.id}}"
      >
        <view class="address_top">{{ group.region }}</view>
        <view class="scroll-content">
          <view
            class="scroll-content-item"
            wx:for="{{group.children}}"
            wx:for-item="item"
            wx:key="{{item.id}}"
            bindtap="handleClick(item)"
          >
            <single-city-card wx:if="{{showSingleCity}}" info="{{item}}" />
            <multi-city-card wx:else info="{{item}}" />
          </view>
        </view>
      </view>
      <view style="height: 32px"></view>
    </scroll-view>
    <!-- 右侧回到顶部按钮 -->
    <image
      wx:if="{{showAnchorFloat &&  srcollTop}}"
      src="https://img-hxy021.didistatic.com/static/starimg/img/4hIuHIrG1l1671782385322.png"
      class="list-fixed"
      bind:tap="scrollToViewTop"
    />
  </view>
</template>

<script>
import mpx, { createComponent } from '@mpxjs/core'
createComponent({
  props: {
    list: {
      type: Array,
      value: []
    },
    showAnchorFloat: {
      type: Boolean,
      value: false
    },
    showSingleCity: {
      type: Boolean,
      value: true
    }
  },
  created() {
    this.formatData()
  },
  data: {
    listMain: [],
    toView: '',
    oHeight: [],
    scrollHeight: 0,
    srcollTop: false
  },
  computed: {},
  methods: {
    /**
     * @description: 点击字母导航定位触发
     */
    scrollToViewFn(id) {
      const { listMain } = this
      if (id === '-1') {
        this.toView = 'inToViewA'
        this.$nextTick(() => {
          setTimeout(() => {
            this.toView = 'inToView' + id
          }, 50)
        })
      } else {
        const index = this.listMain.findIndex((x) => x.id === id)
        if (index > -1) {
          this.toView = 'inToView-1'
          this.$nextTick(() => {
            setTimeout(() => {
              this.toView = 'inToView' + id
            }, 50)
          })
        }
      }
    },
    scrollToViewTop() {
      if (__mpx_mode__ == 'web') {
        this.toView = 'inToViewA'
        this.$nextTick(() => {
          setTimeout(() => {
            this.toView = 'inToView-1'
          }, 50)
        })
      } else {
        this.toView = 'inToView-1'
        this.$forceUpdate()
      }
    },

    /**
     * @description: 点击事件
     * @param {*} city
     */
    handleClick(city) {
      this.triggerEvent('handle', city)
    },

    /**
     * @description: 页面滑动时触发
     */
    onPageScroll(e) {
      this.scrollHeight = e.detail.scrollTop
      if (this.scrollHeight < this.oHeight[0].height) {
        this.srcollTop = false
        return
      }
      this.srcollTop = true
    },

    /**
     * @description: 处理数据格式，及获取分组高度
     */
    formatData() {
      const list = []
      const { id, region, childrenName, itemId, itemName } = {
        id: 'first_upper_letter',
        region: 'first_upper_letter',
        childrenName: 'city_list',
        countyName: 'county_list',
        itemId: 'city_id',
        itemName: 'city_name'
      }
      this.list.forEach((category) => {
        const obj = {
          id: category[id],
          region: category[region],
          children: []
        }
        category[childrenName].forEach((item) => {
          const child = {
            id: item[itemId],
            name: item[itemName],
            ...item
          }
          obj.children.push(child)
        })
        list.push(obj)
      })
      this.listMain = list
      const that = this
      //计算分组高度,mpx.createSelectorQuery()获取节点信息
      this.$nextTick(() => {
        mpx
          .createSelectorQuery()
          .select('#inToView-1')
          .boundingClientRect(function (rect) {
            let number = 0
            number = rect && rect.height + number
            const newArray = [{ height: number, key: rect && rect.dataset.id, name: '热门' }]
            that.oHeight = that.oHeight.concat(newArray)
          })
          .exec()

        let number = 0
        for (let i = 0; i < list.length; ++i) {
          mpx
            .createSelectorQuery()
            .select('#inToView' + list[i].id)
            .boundingClientRect(function (rect) {
              number = rect && rect.height + number
              const newArray = [
                { height: number, key: rect && rect.dataset.id, name: list[i].region }
              ]
              that.oHeight = that.oHeight.concat(newArray)
            })
            .exec()
        }
      })
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        this.formatData()
      }
    }
  }
})
</script>

<style scoped lang="stylus">
.scroll-main
  height 100%
  position relative
.scroll-content
  display flex
  flex-wrap wrap
  padding 0 16px
  justify-content space-between
  &-item
    width 100%
    padding 15px 0px
    font-size 14px
    font-weight 400
    color #000000
    font-family PingFangSC-Regular
    display flex
    flex-direction row
    border-bottom 1px solid RGBA(0, 0, 0, 0.04)
  &::after
    content ''
    width 99px
    max-width 30%
    border 1px solid transparent
.content
  box-sizing border-box
  width 100vw
  height 100%
.location
  width 100%
.location_top
  height 76rpx
  line-height 76rpx
  background #f4f4f4
  color #606660
  font-size 14px
  padding 0 10px
.location_bottom
  height 140rpx
  line-height 140rpx
  color #d91f16
  font-size 14px
  border-top 1px #ebebeb solid
  border-bottom 1px #ebebeb solid
  padding 0 10px
  align-items center
  display -webkit-flex
.address_top
  color #333333
  font-size 14px
  font-family PingFangSC-Semibold
  padding 16px 17px 0px
.location_img
  width 24px
  height 48rpx
  position absolute
  right 10px
  top 62px
.add_city
  width 114px
  height 60rpx
  line-height 60rpx
  text-align center
  border 1px solid #ebebeb
  color #000000
  margin-right 10px
.add_citying
  width 114px
  height 60rpx
  line-height 60rpx
  text-align center
  border 1px solid #09bb07
  color #09bb07
  margin-right 10px
.orientation
  white-space normal
  display inline-block
  width 22px
  height 50rpx
  font-size 14px
  font-weight bold
  color rgb(88, 87, 87)
  text-align center
.top
  margin-bottom 3px
.orientation_region
  padding 12px 16px
  font-size 14px
  display grid
  grid-template-columns repeat(7, 1fr)
  font-family PingFangSC-Regular
  grid-row-gap 7px
  grid-column-gap 8px
  color #999999
  text-align center
  line-height 16px
.orientation_title
  margin-left 16px
  margin-right 25px
  margin-top 16px
  font-size 14px
  font-weight bold
  color #333
  font-family PingFangSC-Semibold
.orientation_city
  padding 1px 0
  width 100%
  background #f6f7f8
  border-radius 8px
  height 36px
  line-height 36px
  font-size 14px
  color #000000
  font-family PingFangSC-Regular
.list-fixed
  position fixed
  bottom 41px
  right 7px
  color #999
  font-size 14px
  height 58px
  width 58px
</style>
<script name='json'>
module.exports = {
  component: true,
  usingComponents: {
    'multi-city-card': './multi-city-card',
    'single-city-card': './single-city-card'
  }
}
</script>
